<h2 mat-dialog-title>Envoyer un email</h2>
<mat-dialog-content class="p-2">
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Expéditeur</mat-label>
    <input matInput [(ngModel)]="data.from" type="email" #fromInput="ngModel" email required>
    @if(fromInput.invalid && fromInput.touched){
      <mat-error>
        Veuillez entrer une adresse email valide
      </mat-error>
    }
  </mat-form-field>
  <mat-form-field appearance="outline" class="d-none w-100">
    <mat-label>Destinataire</mat-label>
    <input matInput [value]="data.to" readonly>
  </mat-form-field>
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Sujet</mat-label>
    <input matInput [(ngModel)]="subject" required #subjectInput="ngModel">
    @if(subjectInput.invalid && subjectInput.touched){
      <mat-error>
        Le sujet est requis
      </mat-error>
    }
  </mat-form-field>
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Message</mat-label>
    <textarea matInput rows="5" [(ngModel)]="text" required #textInput="ngModel"></textarea>
    @if(textInput.invalid && textInput.touched){
      <mat-error>
        Le message est requis
      </mat-error>
    }
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="cancel()">Annuler</button>
  <button mat-raised-button color="primary" (click)="send()" [disabled]="!isFormValid()">Envoyer</button>
</mat-dialog-actions>